import { put, takeLatest, select } from 'redux-saga/effects';

import Immutable from 'seamless-immutable';

import isEqual from 'lodash/isEqual';
import mergers from 'seamless-immutable-mergers';

import { compareByType, formatError } from '../../../libs';
import productAPI from '../../api/product';
import { Types, Creators } from '../../reducers/product';
import getState from '../../utils/getState';
import getToken from '../../utils/getToken';

function getVariations(type, skus) {
  const validValues = [];
  const validImages = [];

  const images = skus.map((elm) => ({
    src: Immutable(elm).getIn(['images', 0, 'small'], '/images/image-not-found.png'),
    diffs: Immutable(elm).getIn(['diffs']),
    id: Immutable(elm).getIn(['id']),
  }));

  images.forEach((img) => {
    const filteredDiffs = img.diffs.filter((dif) => dif.type === type);

    if (filteredDiffs.length && !validValues.includes(filteredDiffs[0].value)) {
      validValues.push(filteredDiffs[0].value);
      const image = {
        src: img.src,
        diff: filteredDiffs[0],
      };

      validImages.push(image);
    }
  });

  return validImages;
}

function findSkuAndOffer(skus = [], offers = [], diffs, isQuery) {
  let selectedSku = skus.find((sku) => isEqual(sku.diffs.sort(compareByType), diffs));
  let selectedOffer = {};
  let variations = [];

  if (selectedSku) {
    selectedOffer = offers.find((offer) => offer.id === selectedSku.id);
  }

  const [sku = {}] = skus;
  const [offer = {}] = offers;

  if (!selectedSku) {
    selectedSku = sku;
    selectedOffer = offer;
  }

  if (
    !isQuery &&
    selectedOffer &&
    !Immutable(selectedOffer).getIn(['availability', 'stock', 'quantity']) &&
    !Immutable(selectedOffer).getIn(['_links', 'sku', 'id'])
  ) {
    for (let index = 0; index < offers.length; index++) {
      if (Immutable(offers).getIn([index, 'availability', 'stock', 'quantity'])) {
        selectedOffer = offers[index];
        selectedSku = skus.find((elm) => elm.id === offers[index].id);
        break;
      }
    }
  }

  if (skus.length > 1) {
    const variationsTypes = selectedSku.diffs ? selectedSku.diffs.map((elem) => elem.type) : [];
    variations = variationsTypes.map((elm) => ({ type: elm, options: getVariations(elm, skus) }));
  }

  return { selectedSku, selectedOffer, variations };
}

function* getProduct({ id, query, sandbox }) {
  try {
    const { app } = yield select(getState);
    const siteId = app.getIn(['config', 'siteId']);
    const token = yield select(getToken);

    const data = yield productAPI.getProduct(siteId, id, app.getIn(['query', 'idSeller']), token);

    const {
      product: {
        skus: { skus },
        ...product
      },
      offer: { offers, seller },
    } = data;

    let objDiffs = Immutable({ diffs: skus[0].diffs });

    if (query.length) {
      objDiffs = objDiffs.merge(
        { diffs: query },
        {
          merger: mergers.updatingByIdArrayMerger,
          mergerObjectIdentifier: 'type',
        }
      );
    }

    const isQuery = Boolean(query.length);

    const diffs = objDiffs.getIn(['diffs']).asMutable().sort(compareByType);

    const { selectedSku = {}, selectedOffer = {}, variations = [] } = findSkuAndOffer(skus, offers, diffs, isQuery);

    product.skus = skus;
    product.seller = seller;
    product.offers = offers;
    product.query = selectedSku.diffs;
    product.sandbox = sandbox;
    product.currentVariation = isQuery ? query : selectedSku.diffs;
    product.variations = variations;

    if (!offers || !skus) {
      throw new Error(`Product ${id} not found`);
    }

    yield put(Creators.getProductSuccess(product));
    yield put(Creators.setCurrentProduct(selectedSku, selectedOffer));
  } catch (error) {
    yield put(Creators.getProductFailed(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.GET_PRODUCT, getProduct);
}
